module.exports = __webpack_public_path__ + "img/4.9bbcf233.jpg";